import {
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import {
  NoResultsBox
} from "./Search.styles";
import {
  Button,
  CardFilter,
  FiltersCarousel,
  GridMain,
  GuardedLink,
  HeroCardSearch,
  Icon,
  Spinner
} from "../../components";
// import { Default as CarouselCardDefaultProps } from "../../components/CarouselCard/CarouselCard.variants";
import { useAnnouncement } from "../../components/Announcement/Announcement.component";
import { CarouselCardRestyle } from "../../components/CarouselCardRestyle/CarouselCardRestyle.component";
import { DefaultSearch as HeroCardVariants } from "../../components/HeroCardSearch/HeroCardSearch.variants";
import {
  STATUS_LO
} from "../../consts";
import {
  useInfiniteSearchQuery,
  useTopRatedQuery,
  useTopicsQuery
} from "../../queries";
// import { filtersCards } from "../../services/mockDetail";
import { useAuthStore, useLanguageStore } from "../../stores";
import { createEndDate, createStartDate } from "../../utils/general";
import { CustomRegex } from "../../utils/regex";
// import { CarouselBox } from "../Explore/Explore.styles";

export function Search() {
  const { t } = useTranslation();
  const { announce } = useAnnouncement();
  const {
    pathname,
    state: routerState
  } = useLocation();
  const theme = useTheme();
  const setSpinnerLoginVisible = useAuthStore(state => state.setSpinnerLoginVisible);
  setSpinnerLoginVisible(false);
  const [selectedTopics, setSelectedTopics] = useState<number[]>([]);
  const language = useLanguageStore(state => state.language)?.id;

  const searchTerm = decodeURIComponent(CustomRegex?.matchPathLeaf(pathname) ?? "");

  const { data: allTopics } = useTopicsQuery({});

  const topicsQuery = selectedTopics.reduce(
    (currentTopicsQuery, currentTopic, currentTopicIndex) => {
      /*  the uri arrives with ..topics= */
      if (currentTopicIndex == 0) {
        return currentTopicsQuery + currentTopic;
      } else {
        return currentTopicsQuery + "&topic=" + currentTopic;
      }
    },
    ""
  );

  const {
    data: results,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isLoading
  } = useInfiniteSearchQuery({
    freeText: searchTerm ?? "",
    topics: selectedTopics
  });

  const topRatedIsEnabled = !isFetching && (
    !results?.pages?.[0]?.learningObjects?.length
    || results?.pages?.[0]?.learningObjects?.length === 0
  );

  const { data: topRated } = useTopRatedQuery({
    enabled: topRatedIsEnabled,
    // additional params
    topics: topicsQuery
  });

  const resultsTopics = results?.pages[0]?.metadata?.topic_ids;


  const filteredTopics =  resultsTopics ? allTopics?.filter(topic => topic.learning_object_associated > 0 &&
    resultsTopics?.some(result => result === topic.id )) :
    allTopics?.filter(topic => topic.learning_object_associated > 0);

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    announce( t("announcement_search"));
  }, []);

  return (
    <GridMain>
      <Stack
        gap={ 1.5 }
        maxWidth="calc(100vw - (100vw - 100%))"
        minWidth={ "100%" }
        marginTop="2rem"
      >
        { !isMobile && <GuardedLink
          alignSelf="flex-start"
          color="info"
          href={ routerState?.previous ?? "/" }
          startIcon={
            <Icon
              color = { theme.customColors.systemPrimary01 }
              icon="arrow_left"
              size={ 24 }
            />
          }
          variant="text"
          sx={ {
            fontSize: ("1.125rem"),
            fontWeight: 400,
            justifyContent:"flex-start",
            lineHeight: (11 / 9),
            paddingTop:theme.spacing(4),
            paddingX:0,
            marginTop:"2rem"

          } }
        >
          { t("back") }
        </GuardedLink>

        }

        {
          (results) ? (<>
            <Typography
              color={ theme.palette.text?.primary }
              fontSize={ isMobile? "1.5rem" : "2rem" }
              lineHeight={ 19 / 16 }
              sx={ { padding: "32px 0 0px" } }
            >
              { getResultsLabel(results?.pages?.[0]?.learningObjects ?? []) } <Typography
                color={ theme.palette.text?.primary }
                component="span"
                fontSize="inherit"
                fontWeight={ 700 }
              >
                “{ searchTerm }”
              </Typography>
            </Typography>
            <Typography sx={ {
              padding: "32px 0 0px",
              [theme.breakpoints.down("sm")]: {
                fontSize: "0.875rem",
                lineHeight: "1.125rem",
                padding: "0"
              }
            } }>
              {
                results?.pages[0].metadata.totalElements
                // results?.pages?.reduce((acc, page) => (
                //   acc + page?.learningObjects?.length ?? 0
                // ), 0) ?? "0"
              } risultati trovati
            </Typography>
          </>

          ) : null
        }

        {
          isLoading ? (
            <Spinner />
          ) :
            (
              results?.pages?.[0]?.learningObjects &&
            results.pages[0].learningObjects.length > 0
            )
              ? (
                <>
                  {
                    filteredTopics && filteredTopics?.length > 0 ?
                      <FiltersCarousel label={ "filters-carousel" }>
                        {
                          filteredTopics.map((topic) => (
                            <CardFilter
                              key={ `search-filter--filter-${topic.id}` }
                              title={ topic.name }
                              coverPublicURL={ topic.url.public_url }
                              onClickhandler={ () => {
                                setSelectedTopics((prev) => {
                                  const newState = [ ...prev ];
                                  const topicIndex = newState.indexOf(topic.id);
                                  if (topicIndex >= 0) {
                                    newState.splice(topicIndex, 1);
                                  } else {
                                    newState.push(topic.id);
                                  }
                                  return newState.sort();
                                });
                              } }
                              selected={ selectedTopics.includes(topic.id) }
                            />
                          )
                          )
                        }
                      </FiltersCarousel> : null

                  }

                  <>
                    { /* <CardsBox $isLoading={ isLoading || isFetchingNextPage }> */ }
                    {
                      results?.pages?.map((page,index) => (
                        <div id="cardBox-results-page" key={ index } style={ { display: "flex", flexWrap: "wrap", flexGrow: 1, gap: "1rem" } }>
                          { page.learningObjects.map((card, loIndex) => {
                            return (
                              <div
                                // className="basic-grid-card"
                                style={ { width:"24.5rem", boxSizing: "content-box" } }
                                key={ `carousel-explore--card-${loIndex}--${language}` }
                                role="region"
                                aria-label={ card.title }
                              >
                                <CarouselCardRestyle
                                  enrollType={ card.enrollType }
                                  endDate={ createEndDate(card) }
                                  booked={ card.status !== STATUS_LO.N && card.status !== STATUS_LO.T }
                                  categories={ card.topicTags || [] }
                                  coverPublicURL={ card?.coverPublicURL }
                                  disabled={ false }
                                  duration={ card.duration }
                                  expirationDate={ card.expirationDate }
                                  ecmRegistration={ card.ecmRegistration }
                                  ecm_specialization={ card.ecm_specialization }
                                  id={ card?.id }
                                  isAutoSubscribeEnable={ card.isAutoSubscribeEnable }
                                  isFavourite={ card.isFavourite }
                                  isMandatory ={ card.isMandatory }
                                  isToj={ card.isToj }
                                  isEditorial={ card.isEditorial }
                                  startDate={ createStartDate(card) }
                                  learningObjectType={ card?.learningObjectType || "" }
                                  learningObjectTypology={ card.learningObjectTypology }
                                  percentageOfCompletion={ card.percentageOfCompletion }
                                  shortDescription={ card.shortDescription }
                                  status={ card.status }
                                  title={ card.title }
                                  canAccessNow={ card.canAccessNow }
                                  isLinkRelative={ card.isLinkRelative }
                                  link={ card.link }
                                  externalFileUrl={ card?.externalFileUrl }
                                  isCarouselView={ false }
                                />
                              </div>
                            );
                          }) }
                        </div>


                      ))
                    }
                  </>
                  {
                    (hasNextPage && !isFetchingNextPage) ? (
                      <Button
                        disabled={ !hasNextPage }
                        disableRipple
                        onClick={ () => fetchNextPage() }
                        sx={ {
                          gap:"0.5rem",
                          margin:"0 auto",
                          width:"fit-content"
                        } }
                      >
                        { t("load_more") }
                        <Icon
                          color={ theme.customColors.systemPrimary02 }
                          icon="dropdown"
                          size={ 24 }
                        />
                      </Button>
                    ) : null
                  }
                  {
                    isFetchingNextPage ? (
                      <Spinner />
                    ) : null
                  }
                </>
              ) : (
                <>

                  <NoResultsBox >
                    <HeroCardSearch
                      { ...HeroCardVariants }
                    />
                  </NoResultsBox>
                  {
                    filteredTopics && filteredTopics?.length > 0 ?

                      <FiltersCarousel label={ "filters-carousel" }>
                        {
                          filteredTopics.map((topic) => (
                            <CardFilter
                              key={ `search-filter--filter-${topic.id}` }
                              title={ topic.name }
                              coverPublicURL={ topic.url.public_url }
                              onClickhandler={ () => {
                                setSelectedTopics((prev) => {
                                  const newState = [ ...prev ];
                                  const topicIndex = newState.indexOf(topic.id);
                                  if (topicIndex >= 0) {
                                    newState.splice(topicIndex, 1);
                                  } else {
                                    newState.push(topic.id);
                                  }
                                  return newState.sort();
                                });
                              } }
                              selected={ selectedTopics.includes(topic.id) }
                            />
                          ) )
                        }
                      </FiltersCarousel> :
                      null

                  }
                </>
              )
        }
      </Stack>
      {
        (topRatedIsEnabled) ? (
          <Stack>
            {
              topRated ? (
                <div id="cardBox-topRated" style={ { display: "flex", flexWrap: "wrap", flexGrow: 1, gap: "1rem" } }>
                  { topRated.map((card, i: number) => {
                    return (
                      <div
                        style={ { width:"24.5rem", boxSizing: "content-box" } }
                        key={ "basic-card-" + i }
                        role="region"
                        aria-label={ card.title }
                      >
                        <CarouselCardRestyle
                          key={ `carousel-explore--card-${card.id}--${language}` }
                          enrollType={ card.enrollType }
                          booked={ card.status !== STATUS_LO.N && card.status !== STATUS_LO.T }
                          categories={ card.topicTags || [] }
                          coverPublicURL={ card?.coverPublicURL }
                          disabled={ false }
                          duration={ card.duration }
                          ecmRegistration={ card.ecmRegistration }
                          ecm_specialization={ card.ecm_specialization }
                          endDate={ createEndDate(card) }
                          expirationDate={ card.expirationDate }
                          id={ card.id }
                          isAutoSubscribeEnable={ card.isAutoSubscribeEnable }
                          isFavourite={ card.isFavourite }
                          isMandatory={ card.isMandatory }
                          isEditorial={ card.isEditorial }
                          isToj={ card.isToj }
                          learningObjectType={ card?.learningObjectType || "" }
                          learningObjectTypology={ card.learningObjectTypology }
                          percentageOfCompletion={ card.percentageOfCompletion }
                          shortDescription={ card.shortDescription }
                          startDate={ createStartDate(card) }
                          status={ card.status }
                          title={ card.title }
                          canAccessNow={ card.canAccessNow }
                          isLinkRelative={ card.isLinkRelative }
                          link={ card.link }
                          externalFileUrl={ card?.externalFileUrl }
                          isCarouselView={ false }
                        />
                      </div>
                    );
                  }) }
                </div>
              ) : null
            }
          </Stack>
        ) : null
      }
    </GridMain>
  );

  function getResultsLabel(results: unknown[]) {
    return (results.length < 1)
      ? t("no_results")
      : t("results");
  }
}
